import { render, staticRenderFns } from "./GridAction.vue?vue&type=template&id=90a68a56&scoped=true"
import script from "./GridAction.vue?vue&type=script&lang=js"
export * from "./GridAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a68a56",
  null
  
)

export default component.exports